module.exports = __webpack_public_path__ + "media/images/dogs/puppy_height_cropped/Bull Terrier (Miniature).jpg";